"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[65458,5854],{

/***/ 115959:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ ChevronDownOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const ChevronDownOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 14 8", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M13.7108 0.295798C13.6178 0.202069 13.5072 0.127675 13.3854 0.0769065C13.2635 0.026138 13.1328 0 13.0008 0C12.8688 0 12.7381 0.026138 12.6162 0.0769065C12.4944 0.127675 12.3838 0.202069 12.2908 0.295798L7.71079 4.87579C7.61783 4.96952 7.50723 5.04391 7.38537 5.09468C7.26351 5.14545 7.13281 5.17159 7.00079 5.17159C6.86878 5.17159 6.73808 5.14545 6.61622 5.09468C6.49436 5.04391 6.38376 4.96952 6.29079 4.87579L1.71079 0.295798C1.61783 0.202069 1.50723 0.127675 1.38537 0.0769065C1.26351 0.026138 1.1328 0 1.00079 0C0.868781 0 0.738075 0.026138 0.616216 0.0769065C0.494357 0.127675 0.383756 0.202069 0.290792 0.295798C0.104542 0.48316 0 0.736611 0 1.0008C0 1.26498 0.104542 1.51843 0.290792 1.70579L4.88079 6.29579C5.44329 6.85759 6.20579 7.17314 7.00079 7.17314C7.7958 7.17314 8.55829 6.85759 9.12079 6.29579L13.7108 1.70579C13.897 1.51843 14.0016 1.26498 14.0016 1.0008C14.0016 0.736611 13.897 0.48316 13.7108 0.295798Z",
          fill: "#43464C"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 635384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ ChevronUpOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const ChevronUpOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 14 8", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M13.0041 7.14336C12.8725 7.14412 12.742 7.11889 12.6202 7.06913C12.4983 7.01937 12.3875 6.94604 12.2941 6.85336L7.71409 2.26337C7.62113 2.16964 7.51053 2.09525 7.38867 2.04448C7.26681 1.99371 7.1361 1.96757 7.00409 1.96757C6.87208 1.96757 6.74137 1.99371 6.61951 2.04448C6.49766 2.09525 6.38705 2.16964 6.29409 2.26337L1.71409 6.85336C1.52579 7.04166 1.27039 7.14745 1.00409 7.14745C0.73779 7.14745 0.482395 7.04166 0.294092 6.85336C0.105788 6.66506 0 6.40966 0 6.14336C0 6.0115 0.0259719 5.88093 0.0764322 5.75911C0.126893 5.63729 0.200853 5.5266 0.294092 5.43336L4.88409 0.853372C5.45403 0.305806 6.21374 0 7.00409 0C7.79445 0 8.55415 0.305806 9.12409 0.853372L13.7141 5.43336C13.8078 5.52633 13.8822 5.63693 13.933 5.75879C13.9838 5.88064 14.0099 6.01135 14.0099 6.14336C14.0099 6.27537 13.9838 6.40608 13.933 6.52794C13.8822 6.6498 13.8078 6.7604 13.7141 6.85336C13.6207 6.94604 13.5098 7.01937 13.388 7.06913C13.2662 7.11889 13.1357 7.14412 13.0041 7.14336Z",
          fill: "#43464C"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 565458:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FAQSection": function() { return /* binding */ FAQSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(982226);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(425336);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(387100);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(212808);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(635384);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(115959);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(684443);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(634655);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(979894);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(891987);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  line-height: 28px;\n  font-size: 20px;\n  font-weight: 700;\n  margin-bottom: 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







const FAQSection = (param)=>{
    let { faq , style  } = param;
    const { isMobile  } = (0,contexts__WEBPACK_IMPORTED_MODULE_3__/* .useTenantConfig */ .Wx)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify({
                            "@context": "https://schema.org",
                            "@type": "FAQPage",
                            mainEntity: faq.map((param)=>{
                                let { question , answer  } = param;
                                return {
                                    "@type": "Question",
                                    name: question,
                                    acceptedAnswer: {
                                        "@type": "Answer",
                                        text: answer
                                    }
                                };
                            })
                        })
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Container */ .W, {
                style: style ? style : isMobile ? {
                    padding: "0px"
                } : {},
                marginBottom: "s8",
                maxWidth: "100%",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Shape */ .b, {
                    borderRadius: "m",
                    backgroundColor: "white",
                    style: {
                        overflow: "hidden"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Shape */ .b, {
                            padding: "s16",
                            borderBottom: "1px solid #0000000F",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledTitle, {
                                children: (0,i18n__WEBPACK_IMPORTED_MODULE_6__.t)("C\xe2u hỏi thường gặp")
                            })
                        }),
                        faq.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MemoFAQItem, {
                                item: item,
                                isLastItem: index === faq.length - 1
                            }, index))
                    ]
                })
            })
        ]
    });
};
const FAQItem = (param)=>{
    let { item , isLastItem  } = param;
    var ref, ref1;
    const contentRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    const { 0: isShowingAnswer , 1: setShowingAnswer  } = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const answers = (ref = item.answer) === null || ref === void 0 ? void 0 : ref.split("\n");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Shape */ .b, {
        borderBottom: isLastItem ? "" : "1px solid #0000000F",
        padding: [
            "s16",
            "s24"
        ],
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Flex */ .k, {
                direction: "row",
                justify: "space-between",
                align: "center",
                backgroundColor: "white",
                gap: "s4",
                onClick: ()=>{
                    setShowingAnswer((previous)=>!previous);
                },
                style: {
                    cursor: "pointer"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .SubTitle */ .DK, {
                        level: 2,
                        color: "textTitle",
                        children: item.question
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Col */ .JX, {
                        width: 15,
                        children: isShowingAnswer ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_10__/* .ChevronUpOutlined */ .G, {
                            size: 14,
                            color: "#43464C"
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_11__/* .ChevronDownOutlined */ .B, {
                            size: 14,
                            color: "#43464C"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Shape */ .b, {
                backgroundColor: "white",
                style: {
                    overflow: "hidden",
                    transition: "height 0.3s ease",
                    height: isShowingAnswer ? (ref1 = contentRef.current) === null || ref1 === void 0 ? void 0 : ref1.clientHeight : 0
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Shape */ .b, {
                    paddingTop: "s12",
                    ref: contentRef,
                    children: answers === null || answers === void 0 ? void 0 : answers.map((line, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .Body */ .uT, {
                            level: 1,
                            color: "textTitle",
                            dangerouslySetInnerHTML: {
                                __html: line
                            }
                        }, index))
                })
            })
        ]
    });
};
const MemoFAQItem = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(FAQItem, (prevProps, nextProps)=>{
    return prevProps.item === nextProps.item && prevProps.isLastItem === nextProps.isLastItem;
});
const StyledTitle = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_12__["default"].h3(_templateObject());


/***/ })

}]);